import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, ScreenType } from '@fgb/core';
import { ErrorStateService } from '@fgb/core';

@Component({
  selector: 'fgb-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent implements OnInit {
  screenType = ScreenType;
  constructor(private router: Router, public errorService: ErrorStateService, private authService: AuthService) {
    if (this.authService.hasCurrentRefreshToken()) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {}
}
